export default "__VITE_ASSET__BKORyVFm__"